import api, { setToken } from '../index';

export function courses(data) {
	return api.get('/user/index', setToken(data.token));
}

export function direction(data) {
	return api.post('/user/add/direction', {direction_id: data.direction_id}, setToken(data.token));
}